const data = {
  "thumbInput": {
    "helpfulnessPrompt": "Heeft dit je geholpen?",
    "helpfulAriaLabel": "Stem als nuttig",
    "unhelpfulAriaLabel": "Stem als niet nuttig",
    "inputPlaceholder": "Welke informatie mis je?",
    "submitButtonLabel": "Versturen",
    "loadingText": "Even bezig...",
    "successMessage": "Bedankt voor je feedback!",
    "errorMessage": "Er is iets fout gegaan"
  },
  "articleThumbInput": {
    "title": "Heeft deze pagina je geholpen?",
    "response": {
      "yes": {
        "textFieldTitle": "Wat vond je behulpzaam?",
        "textFieldDescription": "We gebruiken je antwoord alleen om de pagina te verbeteren en sturen je geen reactie."
      },
      "no": {
        "textFieldTitle": "Wat kan er beter?",
        "textFieldDescription": "We gebruiken je antwoord alleen om de pagina te verbeteren en sturen je geen reactie."
      }
    },
    "textFieldOptionalLabel": "Optioneel",
    "buttons": {
      "yes": "Ja",
      "no": "Nee",
      "submit": "Verstuur je feedback"
    },
    "status": {
      "success": "Bedankt voor je feedback"
    }
  }
};

export default data;